import {BaseFormModel} from './base-form-model';

export class AverageTimeSummary extends BaseFormModel<AverageTimeSummary> {
    averageVisit: number;
    averageWait: number;
    averageReady: number;
    averageDelivery: number;
}
